module.exports = __webpack_public_path__ + "static/media/Screenshot_1-thumb.c1e45687.png";